import { createContext } from 'react';
var PopoverOverflowContext = /*#__PURE__*/createContext({
  isContentOverflowing: null,
  setIsContentOverflowing: null
});
export { PopoverOverflowContext };